<script setup>
import { ref, defineEmits, defineProps } from 'vue';
import { v4 as uuidv4 } from 'uuid';

defineProps({
  id: {
    type: String,
    required: true,
    default: () => uuidv4(),
  },
  hideBtnAfterOpen: {
    type: Boolean,
    default: false,
  },
  moreLabel: {
    type: String,
    default: 'Voir plus',
  },
  lessLabel: {
    type: String,
    default: 'Voir moins',
  },
});

const emit = defineEmits(['open', 'close']);

const isOpen = ref(false);

const openClose = () => {
  isOpen.value = !isOpen.value;

  if (isOpen.value) {
    emit('open');
  } else {
    emit('close');
  }
};
</script>

<template>
  <div class="show-more">
    <button
      v-if="!(isOpen && hideBtnAfterOpen)"
      class="show-more__button"
      @click="openClose"
      :aria-expanded="isOpen"
      :aria-controls="id"
      :tabindex="isOpen ? '' : '-1'">
      <span v-if="isOpen">{{ lessLabel }}</span>
      <span v-else>{{ moreLabel }}</span>
    </button>
    <div
      v-show="isOpen"
      :id="id"
    >
        <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'sass:math';

.show-more {
  &__button {
    display: inline-block;
    text-transform: uppercase;
    font-size: (math.div(13, 16) * 1rem);
    line-height: 1.1em;
    color: inherit;
    text-decoration: none;
    font-weight: 700;
    margin-top: 4px;
    position: relative;
    background: transparent;
    border: 0;
    padding: 0 0 2px;
    transition: all .2s ease;

    &:before {
      content: '';
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: 1.4px;
      background: currentColor;
      transition: all .2s ease, background-color .5s ease;
    }

    &:focus {
      text-decoration: none;
    }

    &:hover {
      text-decoration: none;
      opacity: .85;

      &:before {
        background: transparent;
        right: 100%;
      }
    }
  }
}
</style>
